import { render } from "./TelegramSubscriptionBlock.vue?vue&type=template&id=09871104"
import script from "./TelegramSubscriptionBlock.vue?vue&type=script&lang=js"
export * from "./TelegramSubscriptionBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__